import { useEffect, useMemo, useState } from "react";
import { delivoApi, freshdeskApi } from "../api";
import { initialAccountValues } from "../providers/AccountProvider/initialAccountValues";
import { useAccountInfo } from "./useAccountInfo";
import { GetSupportTicketsRequest } from "../api/freshdeskTypes";

/**
 * Custom hook to fetch and manage Freshdesk support tickets.
 */
export function useSupportTickets(selectedDates) {
  const { accountInfo } = useAccountInfo();
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState([]);

  const fetchSupportTickets = useMemo(
    () => async () => {
      if (!accountInfo.email) {
        return;
      }
      try {
        const tickets = await freshdeskApi.getSupportTickets(
          new GetSupportTicketsRequest({
            email: accountInfo.email,
          }),
        );

        setLoading(false);
        setTickets(tickets);
      } catch (error) {
        console.error("Error fetching support tickets", error);
        setLoading(false);
      }
    },
    [accountInfo.email],
  );

  useEffect(() => {
    fetchSupportTickets();
  }, [fetchSupportTickets]);

  const filteredTickets = useMemo(() => {
    if (!selectedDates) {
      return tickets;
    }
    return tickets.filter(
      (ticket) =>
        new Date(ticket.created_at) <= selectedDates[1] &&
        new Date(ticket.created_at) >= selectedDates[0],
    );
  }, [selectedDates, tickets]);

  return { tickets: filteredTickets, loading, fetchSupportTickets };
}
